import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import axios from "axios";
import { API_BASE_URL } from "../config/constants";

const TransactionGrid = () => {
  const [data, setData] = useState([]);
  const [visibleDataCount, setVisibleDataCount] = useState(7);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const storedId = sessionStorage.getItem("id");
        const token = sessionStorage.getItem("token");

        if (!storedId || !token) {
          setErrorMessage("No ID or token found in sessionStorage.");
          setLoading(false);
          return;
        }

        const headers = { Authorization: `Bearer ${token}` };
        const response = await axios.get(`${API_BASE_URL}booking-list-token/${storedId}`, { headers });

        if (response.data && response.data.data) {
          const filteredData = response.data.data
            .filter((item) => ["P", "S", "A", "F"].includes(item.STATUS))
            .map((item) => ({
              transactionId: item.BOOKING_REFERENCE_NO,
              status: item.STATUS === "P" || item.STATUS === "F" ? "Failed" : "Success",
              date: new Date(item.TRIP_DATE).toLocaleDateString(),
              destination: item.DESTINATION || "Unknown",
              amount: item.AMOUNT || "N/A",
            }));

          setData(filteredData);
        } else {
          setErrorMessage(response.data.message || "No completed transactions found.");
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          setErrorMessage("Your session has expired. Please log in again.");
          navigate("/login");
        } else {
          setErrorMessage("No Booing History!");
        }
      }
      setLoading(false);
    };

    fetchData();
  }, [navigate]);

  const handleSearch = (query) => {
    setSearchQuery(query);
    const filteredData = data.filter((item) =>
      item.transactionId.toString().toLowerCase().includes(query.toLowerCase()) ||
      item.status.toLowerCase().includes(query.toLowerCase()) ||
      item.date.toLowerCase().includes(query.toLowerCase()) ||
      item.destination.toLowerCase().includes(query.toLowerCase()) ||
      item.amount.toString().toLowerCase().includes(query.toLowerCase())
    );
    setData(filteredData);
  };

  const handleLoadMore = () => {
    setVisibleDataCount((prevCount) => prevCount + 7);
  };

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleContainerClick = () => {
    if (isDrawerOpen) {
      setIsDrawerOpen(false);
    }
  };

  return (
    <div className="transaction-grid-container" onClick={handleContainerClick}>
      <header className="navbar-journey">
        <img onClick={() => navigate("/booking")} src="/images/CIAL_Logo.png" alt="Logo" className="logo" />
        <h1 className="heading">
          WELCOME TO <span className="cial-highlight">CIAL</span> ONLINE TAXI BOOKING
        </h1>
        <FaBars className="hamburger-icon" onClick={toggleDrawer} />
      </header>

      {isDrawerOpen && <div className="overlay" onClick={toggleDrawer}></div>}

      <div className="content-journey">
        <h5>Last Transaction Details</h5>
        <div className="search-container">
          <div className="search-icon-container">

          </div>
          <input
            type="text"
            className="search-bar"
            placeholder="Search here"
            value={searchQuery}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>
      </div>

      <div className="transaction-grid">
        {loading ? (
          <p>Loading...</p>
        ) : errorMessage ? (
          <p className="error-message">{errorMessage}</p>
        ) : (
          <>
            <div className="grid-header-two">
              <div className="header-item">Booking Ref Number</div>
              <div className="header-item">Status</div>
              <div className="header-item">Date</div>
              <div className="header-item">Destination</div>
              <div className="header-item">Amount</div>
            </div>

            <div className="grid-body">
              {data.slice(0, visibleDataCount).map((item) => (
                <div className="grid-row" key={item.transactionId}>
                  <div>{item.transactionId}</div>
                  <div style={{ color: "green", fontWeight: "bold" }}>{item.status}</div>
                  <div>{item.date}</div>
                  <div>{item.destination}</div>
                  <div>Rs. {item.amount}</div>
                </div>
              ))}
            </div>

            {visibleDataCount < data.length && (
              <button className="load-more-button" onClick={handleLoadMore}>
                Load More
              </button>
            )}
          </>
        )}
      </div>

      <div className={`drawer ${isDrawerOpen ? "open" : ""}`} onClick={(e) => e.stopPropagation()}>
        <img src="/images/CIAL_White_Logo.png" alt="Logo" className="drawer-logo" />
        <button className="close-drawer" onClick={toggleDrawer} aria-label="Close Drawer">
          ✕
        </button>
        <ul className="drawer-menu">
          <li onClick={() => navigate("/booking")}>BOOK A TAXI</li>
          <li onClick={() => navigate("/journey")}>UPCOMING JOURNEY</li>
          <li onClick={() => navigate("/faq")}>FAQ</li>
          <li onClick={() => {
            localStorage.clear();
            sessionStorage.clear();
            navigate("/")
          }}>LOG OUT</li>
        </ul>
      </div>
    </div>
  );
};

export default TransactionGrid;
